const observer = new MutationObserver(
    (mutationsList, observer) => {
        for (let mutation of mutationsList) {
            if (mutation.type === 'childList' && mutation.target.id === 'fsb_bar') {
                const fsbBarHeight = window.getComputedStyle(mutation.target).height;
                document.querySelector('html').style.setProperty('--fsb-bar-height', fsbBarHeight)
                observer.disconnect();
            }
        }
    }
);

observer.observe(document, {
    childList: true,
    subtree: true,
});
